import React from 'react';
export var A11yClickable = function (_a) {
    var children = _a.children, onClick = _a.onClick;
    return React.cloneElement(children, {
        tabIndex: onClick ? 0 : undefined,
        role: onClick ? 'button' : undefined,
        onKeyDown: function (e) {
            if (!onClick) {
                return;
            }
            if ([' ', 'Enter'].includes(e.key)) {
                e.preventDefault();
                onClick();
            }
        },
        onClick: onClick,
    });
};
